<template>
  <div class="frame_container content_w_710" :class="device.isMobile ? 'frame-container-mobile' : ''" :id="content.key">
    <img
      :src="content.titleBg.src"
      alt=""
      class="frame_img"
      :style="{
        width: content.titleBg.textStyle.width,
        height: content.titleBg.textStyle.height + 'rem' || '',
      }"
    />
    <div v-if="content.category == 'frame_textarea'">
      <el-input
        v-for="(item, index) in content.content"
        :key="index"
        :placeholder="item.placeholder"
        v-model="item.value"
        type="textarea"
        class="note_textarea"
      ></el-input>
    </div>
    <!-- 点拔 start -->
    <div v-if="content.category == 'frame_section'" style="padding: 34rem">
      <p style="text-indent: 40rem;" v-for="(item,index) in content.content" :key="index" :id="item.key">
        <span v-for="(items,indexs) in item.fontContent" :key="indexs" :id="items.key" :style="{
            fontSize: items.textStyle.fontSize + 'rem' || '',
            fontFamily: items.textStyle.fontFamily || '',
            color: items.textStyle.color || '',
            fontWeight: items.textStyle.fontWeight || '',
        }">{{ items.text }}</span>
      </p>
    </div>
    <!-- 点拔 end -->
    <div
      v-if="content.category == 'frame_article_section'"
      style="padding: 40rem 32rem 37rem"
    >
    <p v-for="(item,index) in content.content" :key="index" :id="item.key" :style="{
      textAlign:item.textStyle.textAlign || '',
      textIndent:
            item.textStyle.textIndent &&
            typeof item.textStyle.textIndent === 'string'
              ? item.textStyle.textIndent
              : item.textStyle.textIndent &&
                typeof item.textStyle.textIndent === 'number'
              ? item.textStyle.textIndent + 'rem'
              : '',
    }">
     
      <span v-for="(items,indexs) in item.fontContent" :id="items.key" :key="indexs" 
        :style="{
          fontSize: items.textStyle.fontSize + 'rem' || '',
          fontFamily: items.textStyle.fontFamily || '',
          color: items.textStyle.color || '',
          textAlign: items.textStyle.textAlign || '',
          fontWeight: items.textStyle.fontWeight || '',
        }"
      >{{ items.text }}</span>
    </p>
     
    </div>
    <div v-if="content.category == 'frame_answer'" style="padding: 27rem 32rem">
      <p style="text-indent: 40rem;" :id="content.content[0].key">
        <span v-for="(item,index) in content.content[0].fontContent" :id="item.key" :key="index"
        :style="{
          fontSize: item.textStyle.fontSize + 'rem' || '',
          fontFamily: item.textStyle.fontFamily || '',
          color: item.textStyle.color || '',
          fontWeight: item.textStyle.fontWeight || '',
        }"
        >{{ item.text }}</span>
      </p>
      <div class="answer_content">
        <span
          class="answer_left_tips"
          :style="{
            width: content.content[0].textStyle.textIndent + 'rem' || '',
            fontSize: device.isMobile ? '26rem' : '16rem',
            color:'#333333'
          }"
          >答：</span
        >
        <el-input
          placeholder="请输入您的答案"
          v-model="content.content[0].value"
          type="textarea"
          class="answer_textarea"
        ></el-input>
      </div>
      <p
        class="refer_answer_p"
        @click="isHidden=!isHidden"
        :style="{
          marginLeft:
            content.content[0].textStyle.textIndent &&
            typeof content.content[0].textStyle.textIndent === 'string'
              ? content.content[0].textStyle.textIndent
              : content.content[0].textStyle.textIndent &&
                typeof content.content[0].textStyle.textIndent === 'number'
              ? content.content[0].textStyle.textIndent+17 + 'rem'
              : '',
        }"
      >
        {{!isHidden?'收起':'查看'}}参考答案
      </p>
      <p v-if="!isHidden" style="text-indent: 40rem;" :id="content.content[1].key">
        <span v-for="(item,index) in content.content[1].fontContent" :id="item.key" :key="index" :style="{
          fontSize: item.textStyle.fontSize + 'rem' || '',
          fontFamily: item.textStyle.fontFamily || '',
          color: item.textStyle.color || '',
          fontWeight: item.textStyle.fontWeight || '',
        }">{{ item.text }}</span>
      </p>
    </div>

    <!-- 小互动 start -->
    <div v-if="content.category == 'frame_interact'" style="padding: 0">
      <actionIndex :content="content.content[0]"></actionIndex>
    </div>
    <!-- 小互动 end -->
  </div>
</template>
   
<script>
import actionIndex from "../action/index.vue";

export default {
  components: {
    actionIndex
  },
  data() {
    return {
      isHidden:true,
    };
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created() {},
  methods: {},
};
</script>
   
<style scoped lang='scss'>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 0 auto 20px;
  min-height: 200rem;
  // border: 2rem solid #00a8ac;
  position: relative;
  // background:#F4F9FE ;
  margin-top: 30rem;
  // padding:36rem;
  box-sizing: border-box;
  > div {
    background: #f4f9fe;
    border: 2rem solid #00a8ac;
  }
}
.frame_img {
  display: block;
  width: 100%;
  // position: absolute;
  left: 0;
}
.note_textarea {
  height: 100%;
  min-height: 200rem;
}
/deep/.note_textarea .el-textarea__inner {
  height: 100%;
  min-height: 200rem !important;
  background: #f4f9fe !important;
  outline: none !important;
  border: none !important;
  color: #999999 !important;
  font-size: 18rem !important;
  font-family: SimSun !important;
  padding: 18rem 23rem !important;
  resize: none;
}
.answer_content {
  display: flex;
  margin-top: 28rem;
  width: 100%;
  .answer_content_left {
    color: #333;
    font-size: 26rem;
  }
}
.answer_textarea{
  margin-left: 17rem;
}
/deep/.answer_textarea .el-textarea__inner {
  color: #999999;
  font-size: 18rem;
  border: 1rem solid #999999 !important;
  outline: none !important;
  min-height: 160rem !important;
  flex: 1 !important;
  resize: none;
}
.refer_answer_p {
  margin-top: 22rem;
  color: #0482ec;
  font-size: 18rem;
  cursor: pointer;
}
.frame-container-mobile{
  /deep/.note_textarea .el-textarea__inner {
    height: 100%;
    min-height: 200rem !important;
    font-size: 26rem !important;
  }
  /deep/.answer_textarea .el-textarea__inner {
    font-size: 26rem;
  }
  .refer_answer_p {
    font-size: 26rem;
  }
}
</style>